import React, { useEffect, useContext, useState } from "react"
import RightSideBar from "../section-right-side-bar"
import { applyComma, lineCapital } from "../../../shared/functions"
import { generateBI } from "../../../services/apiservice"
import { JourneyContext } from "../../context/journeyContext"
import { PageContext } from "../../context/pageContext"
import { SectionContext } from "../../context/sectionContext"
import { getValueFromLookup } from "../../services/helperFunctions"
import * as lookup from "../../../../static/lookup.json"
import DocListPDF from "../../../documents/List-of-acceptable-documents.pdf"
export default function GuaranteedFortunePQ(props) {
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)

  const handlePrevious = () => {
    pageState.pageData.map((element, index) => {
      if (
        element.sectionId ===
        props.sections[props.currentSectionIndex - 1].sectionId // setting section context from page context
      ) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: element.sectionId,
            sectionData: element.sectionData,
          }
        })
      }
    })
    props.setCurrentSectionIndex(prev => prev -1)
  }

  const handleProceed = () => {
    props.setCurrentPageIndex(prev => prev + 1)
    props.setCurrentSectionIndex(0)
  }

  // useEffect(async () => {
  //   console.log("journeyState", journeyState)
  //   if (!journeyState.gurantedSavingsBiKeys.premiumAmount) {
  //     let payload = {
  //       journeyId: journeyState.journeyId,
  //     }
  //     const biApiData = await generateBI(payload)
  //     if (biApiData.data?.BIJson) {
  //       let biJson = JSON.parse(biApiData.data?.BIJson)
  //       let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
  //       let expectedBonusAmount = Math.floor(biJson[0]?.["DB_G"])
  //       let gurantedSumAssured = Math.floor(biJson[0]?.["SUM_ASSURED_MATURITY"])
  //       let total = expectedBonusAmount + gurantedSumAssured
  //       setJourneyState(prev => {
  //         return {
  //           ...prev,
  //           gurantedSavingsBiKeys: {
  //             premiumAmount: premiumAmount,
  //             gurantedSumAssured: gurantedSumAssured,
  //             expectedBonusAmount: expectedBonusAmount,
  //             total: total,
  //           },
  //         }
  //       })
  //     }
  //   }
  // }, [])

  return (
    <>
      <style>
        {`
        .seconf-benefit-total .percnt-jeevan {
          height: 190px;
          padding: 80px 9px;
      }
          .mg-ckyc-top.desktop-view-right-side {
            margin-top: 39px;
          }
         
          
        
          @media (max-width: 767px) {
            .seconf-benefit-total .listing-total {
              width: 100%;
          }
            .line-jeev{
                display: none;
              }
            .or-jeevan p {
                width: 45px;
                left: 0px;
                right: 0px;
                margin: auto;
                top: 16px;
            }
            .form-group span#plan_option-error {
              top: 49px;
            }
            .form-group span#policy_term-error {
              top: 51px;
            }
            .form-group span#payment_term-error {
              top: 50px;
            }
            .form-group span#payment_frequency-error {
              top: 51px;
            }
            .or-jeevan p{
              top: -14px;
            }
          }
        
          button.select2-selection__clear {
            display: none;
          }
          .guranteedSumAssurdBox{
            padding: 0px 0px 15px 15px;
          }
        
          .form-group {
            position: relative;
          }
        
          .text-danger {
            color: #a94442;
            position: absolute;
            left: 0;
            bottom: -20px;
          }
          .sas {
            margin: 0px;
            color: #fff;
            text-align: center;
            width: 100%;
            margin-bottom: 15px;
            font-size: 25px;
            background-color: #0bb0f0;
            width: 520px;
            margin: auto;
            z-index: 2;
            position: relative;
        }
        
          #swords {
            position: absolute;
            z-index: 2;
            right: 38px !important;
            top: 0px;
          }
        
          #sumAssured-error {
            position: absolute;
            bottom: -3px;
            z-index: 2;
          }
        
          button.select2-selection__clear {
            display: none;
          }
        
          .sumassuredselect select#nonfilterselect {
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("images/arrow-sm.png");
            background-repeat: no-repeat;
            background-position-x: 99%;
            background-position-y: 17px;
          }
          .leftAlign{
             float: left;
          }
          .rightAlign{
            float: right;
         }
         .money-payout-option-design .title-bg1 {
            color: #fff;
            text-align: center;
            width: 100%;
            font-size: 17px;
        }
        .form-group label {
            margin-left: 8px;
            color: #505050;
            font-size: 15px;
        }
          #words {
            position: absolute;
            right: 58px;
            top: 27px;
          }
        
          select::-ms-expand {
            display: none;
          }
        
          .sumassuredselect {
            position: relative;
            height: 45px;
            width: 100%;
          }
        
          .sumassuredselect input.form-control {
            position: absolute;
            z-index: 2;
            width: calc(100% - 35px);
            left: 3px;
            height: 42px;
            top: 0;
            box-shadow: none;
            border: 0;
            display: block !important;
            background: #ededed;
            border-right-color: transparent;
          }
        
          .sumassuredselect select#nonfilterselect {
            position: absolute;
            top: 0;
            width: 100%;
            left: 0;
            right: 0;
            background: #ededed;
            z-index: 1;
            text-align: center;
            border-left-color: transparent;
          }
          .or-jeevan {
            position: relative;
          }

          @media (max-width: 1440px) {

            .seconf-benefit-totaln  ul.price-jeevan-toal li {
            display: block !important;
            margin-right: 5px;
              text-align: center;
          
        }

        .seconf-benefit-total .total-mrp-jeevan {
          text-align: center;
        }
        .result-design ul.price-jeevan-toal li {
          text-align: left;
      }

      .result-design .seconf-benefit-total .listing-total {
        width: 90%;
    }

    .result-design .total-mrp-jeevan {
      text-align: left;
  }
   }

          @media (min-width: 992px) and (max-width: 1200px) {
          
.percnt-jeevan {
    font-size: 20px;
    padding: 35px 5px;
    height: 90px;
}
.seconf-benefit-total .percnt-jeevan {
  height: 190px;
  padding: 80px 9px;
}
}
          @media (min-width: 1024px) and (max-width: 1366px) {
            .total-mrp-jeevan {
              text-align: center;
          }
            .tot-price-money{
              width: 100% !important;
              padding-left:0px !important;
              font-size: 14px;
            }
            .top_space {
              margin-top: 11vh;
            }
          }
          .result-design {
            background-color: #0bb0f0;
            padding: 20px;
            margin-bottom: 30px;
            float: left;
            width: 100%;
        }
          .total-premium-jeevan-design{
            color: #fff;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #fff;
          }
          .totalpr-jeevan {
            display: inline-block;
            font-size: 25px;
          }
          .price-jeevan {
            display: inline-block;
            font-size: 25px;
            text-decoration: underline;
            margin-left: 20px;
          }
          .total-premium-jeevan-design p {
            margin-top: 7px;
          }
          .total-meturity-jeevan {
            text-align: center;
            color: #fff;
            margin: 50px 0px;
            margin-top: 20px;
        }
          .total-meturity-jeevan h2 {
            background-color: #0bb0f0;
            padding: 4px;
            z-index: 2;
            position: relative;
            width: 540px;
            margin: auto;
            font-size: 25px;
          }
          .line-jeev {
            width: 480px;
            height: 2px;
            background-color: #fff;
            margin: auto;
            margin-top: -15px;
            z-index: 1;
            position: relative;
        }
         
          .jeevan-neeves-premium {
            border: 1px solid #fff;
            padding: 14px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
        }
          .listing-total {
            float: left;
            width: 100%;
          }
          .price-jeevan-toal {
            list-style: none;
            color: #fff;
            padding: 0px;
            font-size: 14px;
          }
          .price-jeevan-toal li {
            display: inline-block;
            margin-right: 5px;
          }
          .text-rt-jeevan {
            text-align: right;
            margin-right: 0px !important;
            float: right;
          }
          .total-mrp-jeevan {
            border-top: 1px solid #fff;
            padding-top: 10px;
            font-size: 23px;
            text-align: right;
            color: #fff;
            font-weight: bold;
          }
          .second-total-price {
            text-align: center;
            padding: 0px;
          }
          .money-payout-option-design {
            background-color: #0bb0f0;
            padding: 30px 20px;
            float: left;
            width: 100%;
        }
        .inside-row {
            margin: 0;
        }
        .white-total-text {
            margin: 0px;
            color: #fff;
            margin-top: 10px;
        }
        .mt-30 {
            margin-top: 30px;
        }
        .tot-price-money {
            padding: 10px;
            background-color: #fff;
            color: #0bb0f0;
            text-align: center;
            font-size: 20px;
        }
        .percnt-jeevan {
          float: right;
          background-color: #fff;
          padding: 35px 9px;
          color: #0bb0f0;
          font-size: 25px;
          height: 110px;
          font-weight: bold;
      }
          .or-jeevan {
            position: relative;
          }
          .or-jeevan {
            text-align: center;
            width: 1px;
            height: 150px;
            background-color: #fff;
            margin: auto;
          }
          .or-jeevan p {
            color: #fff;
            font-size: 20px;
            text-transform: uppercase;
            margin: 50px 10px;
            margin-left: -17px;
            background-color: #0bb0f0;
            position: absolute;
          }
         
          @media (max-width: 991px) and (min-width: 768px){
            .tot-price-money {
              margin-bottom: 10px;
          }
           
          .seconf-benefit-total .percnt-jeevan {
            height: 0px;
            padding: 80px 9px;
            min-height: 190px;
            text-align: center;
        }
          .seconf-benefit-total .listing-total {
            width: 85% !important;
        }

        
        .form-group label .title-bg1{
          margin-left: 0px;
        }
          
            .line-jeev{
                display: none;
              }
            .form-group {
                margin-bottom: 9px;
            }
            .guranteedSumAssurdBox{
              padding: 0px 15px 15px 15px;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 30px;
            }
            .line-jeev {
              width: 94%;
            }
            .wd-total-metrurity {
              width: 100%;
            }
          
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            } 
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              width: 45px;
              left: 0px;
              right: 0px;
              margin: auto;
              top: 16px;
            }
          }
          .seconf-benefit-total .or-jeevan p {
            height: 50px;
            width: 50px;
            margin: auto;
            left: 0px;
            right: 0px;
            margin-top: -15px;
        }
          .seconf-benefit-total .or-jeevan {
            height: 1px;
            width: 100%;
            margin: 40px 0px;
            margin-top: 20px;
        }
          @media (max-width: 767px){
            .seconf-benefit-total .or-jeevan {
              margin-bottom: 30px;
          }
          .seconf-benefit-total .percnt-jeevan {
            height: 100%;
            padding: 5px 0px;
        }
            .or-jeevan p {
                width: 45px;
                left: 0px;
                right: 0px;
                margin: auto;
                top: 16px;
              }
            .sas {
                font-size: 18px;
                width: 100%;
                margin-bottom: 10px;
            }
              .line-jeev{
                display: none;
              }
            .result-design {
                padding: 12px;
                padding-bottom: 30px;
            }
            .pl-pr {
                padding-left: 15px !important;
                padding-right: 15px !important;
            }
            .or-jeevan {
                width: 100%;
                height: 1px;
                margin: 30px 0px;
            }
            
            .wd-total-metrurity {
              width: 100%;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 30px;
            }
            .total-meturity-jeevan h2 {
              font-size: 20px;
              width: 200px;
              display: inline-block;
              margin-top: 15px;
            }
            .line-jeev {
              width: 94%;
            }
            .jeevan-neeves-premium {
              
              padding: 10px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
           
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            }
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan p {
              top: -14px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
          
          }
          .seconf-benefit-total .listing-total {
            float: left;
            width: 90%;
        }
          @media (min-width: 992px)
            .col-lg-12 {
                   flex: 0 0 auto;
                    width: 100%;
               }
          
          @media (min-width: 768px) and (max-width: 991px){
           
            .pl-pr {
              padding: 0px;
            }
            .or-jeevan p {
                margin: auto;
                margin-top: -12px;
                left: 0px;
                right: 0px;
                width: 40px;
                z-index: 1;
            }
            .total-meturity-jeevan h2 {
                font-size: 20px;
                display: inline-block;
                margin-top: 15px;
            }
          
          }
          `}
      </style>
      <div className="container">
        <div className="row ps-4 pe-4">
          <div class="col-lg-9 brd-right mt-20">
            <div class="iselect-padding">
              <div class="iselect-box-design">
                <div class="heading-design">
                  <div class="iselect-padding left-side-head ckyc-w">
                    <h1 class="iselect-heading">Your Premium Quotation</h1>
                  </div>
                </div>
                <div class="result-design summary-detail">
                  <div class="col-md-12">
                    <div class="col-md-12 col-xs-12 pr pl-pr wd-total-metrurity">
                      <div class="total-premium-jeevan-design">
                        <div class="totalpr-jeevan">Premium:</div>
                        <div class="price-jeevan" style={{ textDecoration: "none", marginLeft: "2px" }}><span class="fa fa-rupee"></span><strong>{applyComma(journeyState.guaranteedFortuneBiKeys.premiumAmount) }</strong>
                        <small style={{ "fontSize": "16px" }}> {getValueFromLookup("premiumFrequency", journeyState.paymentFrequency).toLowerCase()}</small>
                        </div>
                        <p style={{ fontStyle: "italic" }}>The premium shown above is exclusive of taxes</p>
                      </div>
                      <div class="col-md-12">
                        <div class="total-meturity-jeevan">
                          <h2> Guaranteed Maturity Benefit</h2>
                          <div class="line-jeev"></div>
                        </div>
                      </div>
                      <div class="jeevan-neeves-premium">

                        <div class="listing-total">
                          <ul class="price-jeevan-toal">
                            <li>Guaranteed Sum Assured</li>
                            <li class="text-rt-jeevan"> <span class="fa fa-rupee"></span> {applyComma(journeyState.guaranteedFortuneBiKeys.guaranteedSA) }</li>
                          </ul>
                          <ul class="price-jeevan-toal">
                            <li>Guaranteed Additions</li>
                            <li class="text-rt-jeevan"> <span class="fa fa-rupee"></span> {applyComma(journeyState.guaranteedFortuneBiKeys.guaranteedAdd) || "0" }</li>
                          </ul>
                          <div class="total-mrp-jeevan" style ={{display:"flex",justifyContent:"right"}}> <span class="fa fa-rupee"></span> {applyComma( journeyState.guaranteedFortuneBiKeys.guaranteedSA + journeyState.guaranteedFortuneBiKeys.guaranteedAdd) }</div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
                <div class="hidden-desktop-screen">
                  <div class="iselect-mg-bottom">
                    <div class="col-md-12">
                      <div class="but-center text-center">
                        <div class="submit-btn cen"  aria-hidden="true" onClick={handlePrevious} > <a>Previous</a> </div>
                        <a>  <input class="previous-btn cen inline-btn-wd"   aria-hidden="true" onClick={handleProceed} style={{ color: "white", border: "none",backgroundColor: "#f8be15" }} type="Proceed" value="View BI To Proceed" /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
</div>
          {/* <RightSideBar sections={props.sections} currentSectionIndex={props.currentSectionIndex} /> */}
        </div>
      </div>

      {/* Mobile view Buttons */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="row">
            <div className="col-lg-12">
              <div className="but-center text-center">
                <div className="submit-btn cen"  aria-hidden="true" onClick={handlePrevious} style={{ paddingLeft: "5px" }}  > <a >Previous </a> </div>
                <input className="previous-btn cen bi-btv"   aria-hidden="true" onClick={handleProceed} style={{ color: "white", padding: "14px 0px", border: "none", marginLeft: "10px", width: "160px", backgroundColor: "#f8be15" }} type="button" form="aDetail" align="right" value="View BI to Proceed" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
